//Stat counter
$.fn.isOnScreen = function(){

    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

var fired = 0;
  $(window).scroll(function(){
    if(fired === 0) {
      $('.numerical-counter').each(function () {
        $(this).prop('Counter',0).animate({
          Counter: $(this).text()
        }, {
          duration: 6000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now).toLocaleString('en'));
          }
        });
      });
      fired = 1; //Only do scroll function once
    }
});
